import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function MinusMark({ color = 'status.pink', ...props }) {
  return (
    <IconBase viewBox='0 0 10 4' {...props}>
      <Path
        d='M8.57254 1.98703H1.42969'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

MinusMark.propTypes = {
  color: PropTypes.string,
}

export default MinusMark
